import React, { useState } from "react";

export default function Weather(props) {
    const [unit, setUnit] = useState ("celsius");
    function showFahrenheit (event) {
    event.preventDefault();    
    setUnit("fahrenheit")
    }
    function showCelsius (event) {
    event.preventDefault();    
    setUnit("celsius")
    }

if (unit === "celsius") {
   return (
<div className= "WeatherTemp">
        <h3 >
            <span className= "temp" >{props.celcius}</span>
            <span className= "unit" >°C |{""}<a href="/" onClick={showFahrenheit}>°F </a> </span>
        </h3>
</div>
    )  

}else {
    let fahrenheit = Math.round(props.celcius * 9/5) + 32;
    return (
<div className= "WeatherTemp">
        <h3 >
            <span className= "temp" >{fahrenheit}</span>
            <span className= "unit" ><a href="/" onClick={showCelsius}>°C</a> {""} |°F </span>
        </h3>
</div>
    )
} 
}